import React from 'react'
import Header from './Components/Header/Header'
import Footer from './Components/Footer/Footer'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
library.add(fas, fab)


const PageNotFound = () => {
  return (
    <div>
      
      <Header/>
      <main>
      
          <section className='connect-section ws-section pb-5'>
            <div className='container'>
                <div class="row">
                  <div class="col-lg text-center">
                    <h2 class="ws-section_heading" style={{ marginBottom: "0" }}>404 Error</h2>
                    <h2>Page Not Found</h2>
      <p>Sorry, the page you are looking for doesn't exist.</p>

      <a href="https://www.takshila-vlsi.com/">Go Back Home</a>
                  </div>
                </div>
            </div>
          </section>
          
      </main>
      <Footer/>
    </div>
  )
}

export default PageNotFound